import React, { memo, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

// PosHeader wstrzykuje akcje POS do paska gornego (Topbar) przez dwa sloty:
//  - pos-topbar-nav   : nawigacja (zakladki Kasa/Paragony/Szkice/Raporty) + skaner
//    (zapis szkicu jest przy koszyku - przycisk "Szkic" w CartHeader)
//  - pos-topbar-shift : otwarcie / zamkniecie zmiany
// Status drukarki fiskalnej pokazuje juz globalny FiscalPrinterButton w Topbar,
// wiec NIE dublujemy go tutaj (wczesniej byly dwa wskazniki obok siebie).
const PosHeader = ({
  currentShift,
  activeTab,
  setActiveTab,
  barcodeScannerEnabled,
  setBarcodeScannerEnabled,
  barcodeSearching,
  onOpenShift,
  onCloseShift,
  onLoadReports,
  loading
}) => {
  const [navSlot, setNavSlot] = useState(() => document.getElementById('pos-topbar-nav'));
  const [shiftSlot, setShiftSlot] = useState(() => document.getElementById('pos-topbar-shift'));

  useEffect(() => {
    if (navSlot && shiftSlot) return;
    const t = setInterval(() => {
      const n = document.getElementById('pos-topbar-nav');
      const s = document.getElementById('pos-topbar-shift');
      if (n) setNavSlot(n);
      if (s) setShiftSlot(s);
      if (n && s) clearInterval(t);
    }, 30);
    return () => clearInterval(t);
  }, [navSlot, shiftSlot]);

  // Grupa 1: nawigacja (segmentowany przelacznik) + narzedzia
  const navContent = (
    <>
      {/* Zakladki jako jeden przelacznik */}
      <div className="topbar-seg" role="tablist">
        <button
          className={activeTab === 'pos' ? 'is-active' : ''}
          onClick={() => setActiveTab('pos')}
        >
          Kasa
        </button>
        <button
          className={activeTab === 'paragony' ? 'is-active' : ''}
          onClick={() => setActiveTab('paragony')}
        >
          Paragony
        </button>
        <button
          className={activeTab === 'szkice' ? 'is-active' : ''}
          onClick={() => setActiveTab('szkice')}
        >
          Szkice
        </button>
        <button
          className={activeTab === 'raporty' ? 'is-active' : ''}
          onClick={() => {
            setActiveTab('raporty');
            if (onLoadReports) onLoadReports();
          }}
        >
          Raporty
        </button>
      </div>

      <div className="topbar-divider" aria-hidden="true" />

      {/* Skaner kodow */}
      <label
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '5px',
          padding: '0.34rem 0.55rem',
          fontSize: '11px',
          color: barcodeScannerEnabled ? 'var(--success)' : 'var(--text-secondary)',
          cursor: 'pointer',
          border: barcodeScannerEnabled ? '1px solid var(--success)' : '1px solid var(--border)',
          backgroundColor: 'var(--card-bg)',
          borderRadius: '6px',
          lineHeight: 1.2,
          whiteSpace: 'nowrap',
        }}
        title={barcodeScannerEnabled ? 'Skaner aktywny - skanuj produkty' : 'Skaner wylaczony'}
      >
        <input
          type="checkbox"
          checked={barcodeScannerEnabled}
          onChange={(e) => setBarcodeScannerEnabled(e.target.checked)}
          style={{ margin: 0, cursor: 'pointer' }}
        />
        📷 {barcodeSearching ? 'Szukam...' : 'Skanuj'}
      </label>
    </>
  );

  // Grupa 2: zmiana (otwarcie / zamkniecie)
  const shiftContent = currentShift ? (
    <button
      data-pos-btn="true"
      style={{
        padding: '0.34rem 0.7rem',
        fontSize: '11px',
        border: '1px solid var(--danger)',
        backgroundColor: 'var(--card-bg)',
        color: 'var(--danger)',
        borderRadius: '6px',
        lineHeight: 1.2,
        fontWeight: 600,
        whiteSpace: 'nowrap',
      }}
      onClick={onCloseShift}
      disabled={loading}
    >
      {loading ? '...' : '⏹ Zamknij zmianę'}
    </button>
  ) : (
    <button
      data-pos-btn="true"
      style={{
        padding: '0.34rem 0.7rem',
        fontSize: '11px',
        border: '1px solid var(--success)',
        backgroundColor: 'var(--success)',
        color: '#fff',
        fontWeight: 600,
        borderRadius: '6px',
        lineHeight: 1.2,
        whiteSpace: 'nowrap',
      }}
      onClick={onOpenShift}
      disabled={loading}
    >
      {loading ? '...' : '▶ Otwórz zmianę'}
    </button>
  );

  return (
    <>
      {navSlot && createPortal(navContent, navSlot)}
      {shiftSlot && createPortal(shiftContent, shiftSlot)}
    </>
  );
};

export default memo(PosHeader);
